<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-subheader class="text-h5 pa-0 pb-4">{{
      $t('DASHBOARD.LAST_REGISTERED_USERS')
    }}</v-subheader>

    <registration-list :items="users" @show="showUser" />
  </v-sheet>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'Registration',

  components: {
    RegistrationList: () =>
      import('@/modules/statistic/components/Registration/RegistrationList')
  },

  data() {
    return {
      users: []
    };
  },

  created() {
    this.retrieveUsers()
      .then(({ data }) => {
        this.users = data.data;
      })
      .catch(error => {
        console.log('Error', error.message);
      });
  },

  methods: {
    ...mapActions('statistic', ['retrieveUsers']),

    showUser(user) {
      this.$router.push({
        name: 'persons.show',
        params: { id: user.person_id }
      });
    }
  }
};
</script>
